export const ActionTypes = {
  FETCH_AUXILIARY_GRID: 'services/dashboards/auxiliaryDashboardService/fetch_auxiliary_grid',
  SET_AUXILIARY_GRID: 'services/dashboards/auxiliaryDashboardService/set_auxiliary_grid',
  SET_LOADER_STATUS: 'services/dashboards/auxiliaryDashboardService/set_loader_status',
};

const fetchAuxiliaryGrid = ({ auxGridParams }) => ({
  auxGridParams,
  type: ActionTypes.FETCH_AUXILIARY_GRID,
});

const setAuxiliaryGrid = ({ auxGrid }) => ({
  auxGrid,
  type: ActionTypes.SET_AUXILIARY_GRID,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});
export default {
  fetchAuxiliaryGrid,
  setAuxiliaryGrid,
  setLoader,
};
